import { gql } from '@apollo/client';

export const REACT_VIRTUAL_HUMAN_SHARE_TOKEN = gql`
  query reactVHShareToken($sharetoken: String!) {
    readOneVirtualHuman(filter: { ShareToken: { eq: $sharetoken } }) {
      ID
      OrganisationID
      ShowRegister
      ShareLoginRequired
      PlayerType
      Organisation {
        ID
        VirtualHumanAPI
      }
    }
  }
`;

export const READ_VIRTUAL_HUMAN_FOR_PLAYER = gql`
  query readOneVirtualHumanForPlayer($filter: VirtualHumanFilterFields!) {
    readOneVirtualHuman(filter: $filter) {
      ID
      Created
      LastEdited
      AuthorID
      CreationMethod
      Author {
        ID
        Name
      }
      ShowRegister
      Title
      AdminTitle
      Description
      OrganisationID
      Organisation {
        ID
        Name
        CustomerStage
        Partner
        MicrophoneBehavior
      }
      Status
      ThumbnailURL
      Thumbnail {
        ID
        URL
        TusID
      }
      Avatar {
        ID
        Name
        Gender
        ImageMedia {
          ID
          URL
          TusID
        }
      }
      HeyGenAvatar {
        ID
        Name
        DisplayName
        Gender
        Deprecated
        ImageMedia {
          ID
          URL
          TusID
        }
      }
      PlayerType
      ShowLanguageSelection
      Voice
      VHVoiceID
      Views
      Likes
      Featured
      CoursesOnly
      DownloadVersion
      ExternalID
      APIEndpoint
      TotalUsers
      TotalCompletions
      Views
      AverageScore
      Diagnosis
      TimeLimit
      DisableHelp
      Type
      EasyMode
      ImageMedia {
        ID
        URL
        TusID
      }
      ImageMediaID
      HideScoresFromUsers
      PublicAccess
      Environment {
        ID
        Name
        Description
        URL
      }
      VHVoice {
        ID
        Locale
        Code
        Name
        Service
      }
      Editors {
        edges {
          node {
            ID
            Name
          }
        }
      }
      FeedbackFormBefore {
        ID
        Title
        Hash
      }
      FeedbackFormAfter {
        ID
        Title
        Hash
      }
      ShareToken
      Outfit {
        Slug
      }
    }
  }
`;
